<template>
  <div class="user_center_info">
    <div><img style="width: 6.67vw; height: 6.67vw" :src="Login.avatar" /></div>
    <div>
      {{
        info.type === "company" ? info.enterpriseName : info.supplierName
      }}，欢迎您！
    </div>
    <div class="user_info_font">
      {{ info.type === "company" ? "税号:" : "供应商编号:"
      }}{{ info.serialNumber }}{{ info.socialCreditCode }}
    </div>
    <div class="user_info_font">
      手机号码：{{ info.supplierPhone }}{{ info.phone }}
    </div>
    <div class="user_info_font">
      审核状态：{{
        info.type === "company"
          ? getDictMapItem(
              "enterprise_status",
              info.enterpriseAuditStatus.toString()
            ).label
          : getDictMapItem("supplier_audit_status", info.certificationStatus)
              .label
      }}
    </div>
    <div class="modify_user_info" @click="$parent.openSupplierModify">
      [编辑{{ info.type === "company" ? "企业" : "个人" }}信息]
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import initDict from "@/mixins/initDict";
export default {
  mixins: [initDict],
  computed: {
    ...mapGetters(["Login"]),
  },
  props: {
    info: Object,
  },
  created() {
    this.$nextTick(() => {
      this.getDictMap("supplier_audit_status,enterprise_status");
    });
  },
};
</script>

<style>
.user_center_info {
  display: grid;
  padding-left: 2.7vw;
  padding-top: 2.7vw;
  grid-template-columns: 6.66vw 30vw;
  grid-template-rows: 1.4vw 0.8vw 0.8vw 0.8vw 0.93vw;
  text-align: left;
  grid-column-gap: 1.9vw;
  grid-row-gap: 0.7vw;
}

.user_center_info > div:nth-child(1) {
  grid-row-start: 4 span;
}

.user_center_info > div:nth-child(2) {
  height: 1.406vw;
  font-family: MicrosoftYaHei;
  font-size: 1.354vw;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: -0.068vw;
  color: #ff731a;
}
.user_info_font {
  height: 3.75vw;
  font-family: AdobeHeitiStd-Regular;
  font-size: 0.833vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.458vw;
  letter-spacing: 0vw;
  color: #666666;
}
.modify_user_info {
  text-align: center;
  height: 0.938vw;
  font-family: AdobeHeitiStd-Regular;
  text-decoration: underline;
  font-size: 0.833vw;
  font-weight: normal;
  font-stretch: normal;
  line-height: 1.458vw;
  letter-spacing: 0vw;
  color: #005bff;
}
</style>
